import { render, staticRenderFns } from "./TargetAudience.vue?vue&type=template&id=889242c6&scoped=true&"
import script from "./TargetAudience.vue?vue&type=script&lang=js&"
export * from "./TargetAudience.vue?vue&type=script&lang=js&"
import style0 from "./TargetAudience.vue?vue&type=style&index=0&id=889242c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889242c6",
  null
  
)

export default component.exports